<template>
    <div class="contact flex wrap center"
        :class="[{ 'established': description === 'established' }, { 'results': data?.status?.results }]">
        <div class="flex wrap center">
            <div class="profile flex center vcenter"
                :class="{ 'small': unregistered && blacklist && !data?.status?.results }">
                <img v-lazy="data?.extras?.rank?.symbol ? `/images/ranks/${data?.extras?.rank?.symbol}` : '/images/profile.webp'"
                    alt="profile" loading="lazy">
            </div>
            <div class="identity flex wrap center vcenter">
                <div class="flex wrap center">
                    <h6 @click.prevent="oncopy('name', data?.extras?.display_name || data?.session?.remote_identity?._display_name || 'هویت نامشخص'
                    )">{{ copied['name'] || data?.extras?.display_name ||
                        data?.session?.remote_identity?._display_name || 'هویت نامشخص'
                        }}
                    </h6>
                    <p @click.prevent="oncopy('phone', mobile || 'فاقد شناسه اتصال')">{{ copied['phone'] || mobile ||
                        'فاقد شناسه اتصال'
                        }}</p>
                    <div v-if="description === 'established' && duration > 1704054600000" class="information">
                        <p>{{ String(base.Util().time({ unix: duration, time: true }))?.split(' ')[0] }}</p>
                    </div>
                    <span v-if="blacklist && description !== 'established' && !data?.status?.results">در
                        مکالمه دقت نمایید! از ارائه
                        اطلاعات
                        حساس خودداری کنید و هویت تماس‌گیرنده را تأیید کنید.</span>
                </div>
            </div>
            <div v-if="description === 'established'" class="states flex wrap center vcenter">
                <div class="flex wrap center vcenter" @click.prevent="$emit('dialpad', this.duration)">
                    <img v-lazy="'/images/dialpad.webp'" alt="dialpad" loading="lazy">
                </div>
                <div class="flex wrap center vcenter" @click.prevent="$emit('mute')">
                    <img v-lazy="data?.status?.mute
                        ? '/images/microphone_off.webp'
                        : '/images/microphone_on.webp'" alt="microphone" loading="lazy">
                </div>
                <div class="flex wrap center vcenter" @click.prevent="$emit('hold')">
                    <img v-lazy="data?.status?.hold
                        ? '/images/pause_on.webp'
                        : '/images/pause_off.webp'" alt="pause" loading="lazy">
                </div>
                <div class="flex wrap center vcenter" @click.prevent="$emit('keypad', this.duration)">
                    <img v-lazy="'/images/forward.webp'" alt="forward" loading="lazy">
                </div>
            </div>
            <div v-if="data?.status?.results" class="flex wrap center vcenter">
                <MetaBox :meta="{
                    key: 'description',
                    type: 'textarea',
                    name: 'خلاصه نتیجه تماس',
                    extras: 'R0:key=minimal,value=YES'
                }" @onchange="onchange"></MetaBox>
                <div class="rates flex wrap space vcenter">
                    <template v-for="(item, index) in rates" :key="index">
                        <div :class="[{ 'active': models['rate'] === item.value }]">
                            <img v-lazy="`/images/${item.icon}.webp`" :alt="item.icon" loading="lazy" @click.prevent="() => {
                                models['rate'] = item.value
                            }">
                        </div>
                    </template>
                </div>
                <div class="shares flex wrap center vcenter">
                    <div class="flex wrap center vcenter" @click.prevent="">
                        <img v-lazy="'/images/socials/telegram.webp'" alt="telegram" loading="lazy"
                            @click.prevent="chat('telegram')">
                    </div>
                    <div class="flex wrap center vcenter" @click.prevent="">
                        <img v-lazy="'/images/socials/whatsapp.webp'" alt="whatsapp" loading="lazy"
                            @click.prevent="chat('whatsapp')">
                    </div>
                    <div class="flex wrap center vcenter" @click.prevent="">
                        <img v-lazy="'/images/socials/eitaa.webp'" alt="eitaa" loading="lazy"
                            @click.prevent="chat('eitaa')">
                    </div>
                    <div class="flex wrap center vcenter" @click.prevent="">
                        <img v-lazy="'/images/socials/bale.webp'" alt="bale" loading="lazy"
                            @click.prevent="chat('bale')">
                    </div>
                </div>
                <Button :meta="{
                    key: 'submit',
                    name: 'ثبت نتیجه تماس'
                }" :active="loading" :disabled="disabled" @onclick="submit"></Button>
            </div>
            <div v-if="description === 'established'" class="shares flex wrap center vcenter">
                <div class="flex wrap center vcenter" @click.prevent="">
                    <img v-lazy="'/images/socials/telegram.webp'" alt="telegram" loading="lazy"
                        @click.prevent="chat('telegram')">
                </div>
                <div class="flex wrap center vcenter" @click.prevent="">
                    <img v-lazy="'/images/socials/whatsapp.webp'" alt="whatsapp" loading="lazy"
                        @click.prevent="chat('whatsapp')">
                </div>
                <div class="flex wrap center vcenter" @click.prevent="">
                    <img v-lazy="'/images/socials/eitaa.webp'" alt="eitaa" loading="lazy"
                        @click.prevent="chat('eitaa')">
                </div>
                <div class="flex wrap center vcenter" @click.prevent="">
                    <img v-lazy="'/images/socials/bale.webp'" alt="bale" loading="lazy" @click.prevent="chat('bale')">
                </div>
            </div>
            <div v-if="!data?.status?.results && data?.extras?.uid" class="flex wrap center vcenter">
                <div class="refer flex wrap vcenter" @click.prevent="$router.push({
                    path: `/Dashboard/Form/Account/${data?.extras?.uid}`
                })">
                    <div class="icon flex wrap center vcenter">
                        <img v-lazy="'/images/user.webp'" alt="profile" loading="lazy">
                    </div>
                    <p>نمایه کاربری</p>
                </div>
                <div class="refer flex wrap vcenter" @click.prevent="() =>
                    $router.push({
                        path: `/Dashboard/Inquiry/Internal`,
                        query: { value: data?.extras?.username }
                    })">
                    <div class="icon flex wrap center vcenter">
                        <img v-lazy="'/images/inquiry.webp'" alt="inquiry" loading="lazy">
                    </div>
                    <p>استعلام و عملیات</p>
                </div>
                <div class="ranks flex wrap center vcenter">
                    <p>نام سطح: <span>{{ data?.extras?.rank?.name || 'بدون سطح' }}</span></p>
                    <p v-if="!blacklist">توضیحات: <span>{{ data?.extras?.rank?.description }}</span></p>
                    <p>امتیاز: <span>{{ data?.extras?.rank?.rate || 0 }}</span></p>
                </div>
            </div>
            <div v-else-if="!data?.status?.results && unregistered && !_registered"
                class="newsletter flex wrap center vcenter">
                <MetaBox :meta="{
                    key: 'name',
                    type: 'text',
                    name: 'نام و نام خانوادگی'
                }" @onchange="onchange"></MetaBox>
                <MetaBox :meta="{
                    key: 'username',
                    type: 'nid',
                    name: 'شناسه ملی'
                }" @onchange="onchange"></MetaBox>
                <Button :meta="{
                    key: 'submit',
                    name: 'ثبت در خبرنامه'
                }" :active="loading" :disabled="disabled" @onclick="newsletter"></Button>
            </div>
            <span v-if="blacklist && description === 'established'" class="notice">در مکالمه دقت نمایید!
                از ارائه
                اطلاعات
                حساس خودداری کنید و هویت تماس‌گیرنده را تأیید کنید.</span>
            <div v-if="!data?.status?.results" class="actions flex wrap center vcenter">
                <img v-lazy="'/images/decline.webp'" width="42" height="42" alt="decline" loading="lazy" @click.prevent="description === 'incoming'
                    ? $emit('reject')
                    : $emit('hangup')">
                <img v-if="!(description === 'dialing' || description === 'established')" v-lazy="'/images/answer.webp'"
                    width="42" height="42" alt="answer" loading="lazy" @click.prevent="$emit('answer')">
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import MetaBox from '../Form/Inputs/MetaBox.vue'
import Button from '../Form/Button.vue'

export default {
    name: 'Calling',
    props: ['data'],
    inject: ['base'],
    components: { MetaBox, Button },
    computed: {
        description() {
            return this.data?.status?.description
        },
        results() {
            return this.data?.status?.results
        },
        mobile() {
            return String(this.data?.session?.remote_identity.uri).split(':')[1].split('@')[0]
        },
        _registered() {
            return this.registered
        },
        unregistered() {
            return this.data?.extras?.context !== 'newsletter' || !this.data?.extras?.display_name
        },
        blacklist() {
            return this.data?.extras?.blacklist
        }
    },
    created() {
        if (this.data?.duration) {
            this.duration = this.data?.duration
            this.stopwatch = setInterval(() => this.duration += 1000, 1000)
            window.addEventListener("beforeunload", this.beforeunload)
        }
    },
    beforeUnmount() {
        clearInterval(this.stopwatch)
    },
    data() {
        return {
            stopwatch: null,
            duration: 1704054600000,
            models: {
                rate: 5
            },
            hints: {},
            errors: {},
            loading: false,
            disabled: false,
            registered: false,
            copied: {},
            rates: [
                {
                    icon: 'happy',
                    value: 5
                },
                {
                    icon: 'smile',
                    value: 4
                },
                {
                    icon: 'suprise',
                    value: 3
                },
                {
                    icon: 'sad',
                    value: 2
                },
                {
                    icon: 'angry',
                    value: 1
                }
            ]
        }
    },
    watch: {
        description(newDescription, oldDescription) {
            if (this.description === 'established') {
                this.duration = 1704054600000
                this.stopwatch = setInterval(() => this.duration += 1000, 1000)
                window.addEventListener("beforeunload", this.beforeunload)
            } else if (this.stopwatch)
                clearInterval(this.stopwatch)
        },
        results(newResults, oldResults) {
            this.loading = false
        }
    },
    methods: {
        onchange(obj) {
            this.models[obj.key] = obj.value
            this.hints[obj.key] = obj.hint
            this.errors[obj.key] = obj.error
        },
        beforeunload(event) {
            event.preventDefault()
            event.returnValue = ''
        },
        submit() {
            if (!this.base.Util().validate(this.models['description'])) {
                this.base.Notification().error({
                    code: 1000,
                    text: 'خلاصه نتیجه تماس'
                })
                return
            }

            const src_uid = this.data?.direction === 'incoming'
                ? this.data?.extras?.uid
                : '{My:0}'

            const dst_uid = this.data?.direction === 'incoming'
                ? '{My:0}'
                : this.data?.extras?.uid

            this.loading = true
            this.base.API().post(`Stream/CDR/Register`, {
                data: [{
                    uid: `${(src_uid || '')},${(dst_uid || '')}`,
                    cid: null,
                    src: this.data?.direction === 'incoming'
                        ? this.mobile
                        : this.data?.username,
                    src_uid: src_uid,
                    src_rate: this.data?.direction === 'incoming'
                        ? null
                        : this.models['rate'],
                    dst: this.data?.direction === 'incoming'
                        ? this.data?.username
                        : this.mobile,
                    dst_uid: dst_uid,
                    dst_rate: this.data?.direction === 'incoming'
                        ? this.models['rate']
                        : null,
                    dcontext: null,
                    channel: null,
                    dst_channel: null,
                    last_app: null,
                    last_data: null,
                    duration: (this.duration - 1704054600000) / 1000,
                    billsec: null,
                    disposition: 'ANSWERED',
                    amaflags: null,
                    account_code: null,
                    unique_id: null,
                    user_field: this.data?.information?.unique_id,
                    did: null,
                    recordingfile: null,
                    cnum: null,
                    cnam: null,
                    outbound_cnum: null,
                    outbound_cnam: null,
                    dst_cnam: null,
                    linked_id: null,
                    peer_account: null,
                    sequence: null,
                    description: this.models['description'],
                    called_at: this.data?.information?.called_at || null
                }]
            }, (response) => {
                this.loading = false
                if (this.base.Util().success(response)) {
                    window.removeEventListener('beforeunload', this.beforeunload)
                    this.base.Notification().toast('نتیجه عملیات', 'ثبت با موفقیت انجام گردید!', 'success')
                    this.$emit('cleanup')
                } else
                    this.base.Notification().error({
                        code: response.data.errorCode,
                        referr: 'cdr'
                    })
            }, (error) => {
                this.loading = false
                this.base.Notification().error({
                    code: 5000,
                    text: 'خطایی رخ داد، لطفا مجددا تلاش کنید!'
                })
            })
        },
        newsletter() {
            if (!this.base.Util().validate(this.models['name'])) {
                this.base.Notification().error({
                    code: 1000,
                    text: 'نام و نام خانوادگی'
                })
                return
            }

            if (this.errors['username']) {
                this.base.Notification().error({
                    code: 1000,
                    text: 'شناسه ملی'
                })
                return
            }

            this.loading = true
            this.base.API().post('Supplement/Newsletter/Register', {
                data: [
                    {
                        receptor: this.mobile,
                        name: this.models['name'],
                        username: this.base.Util().validate(this.models['username'])
                            ? this.models['username']
                            : null
                    }
                ]
            }, (response) => {
                this.loading = false
                if (this.base.Util().success(response)) {
                    if (this.base.Util().validate(response.data.data)) {
                        this.registered = true
                        this.base.Notification().toast('نتیجه عملیات', 'عضویت در خبرنامه آتیه ایرانیان باموفقیت انجام گردید!', 'success')
                    }
                } else
                    this.base.Notification().error({
                        code: response.data.errorCode,
                        referr: 'newsletter'
                    })
            }, (error) => {
                this.loading = false
                this.base.Notification().error({
                    code: 5000,
                    text: 'خطایی رخ داد، لطفا مجددا تلاش کنید!'
                })
            })
        },
        chat(social) {
            switch (social) {
                case 'telegram':
                    window.open(`tg://resolve?phone=${this.mobile}`)
                    break
                case 'whatsapp':
                    window.open(`whatsapp://send?phone=${this.mobile}&text=`)
                    break
                default:
                    break
            }
        },
        oncopy(key, value) {
            navigator.clipboard.writeText(value)
            this.copied[key] = 'کپی شد!'
            setTimeout(() => {
                this.copied[key] = ''
            }, 500)
        }
    }
}
</script>

<style scoped src="../../assets/css/components/phone/calling.css"></style>
<style scoped src="../../assets/css/components/phone/calling_dark.css"></style>